export default __webpack_public_path__ + "static/0005-e1e4040d6c90a8414757040f3f42baf3.png";